import { Download, ExternalLink } from "lucide-react";
import { useState } from "react";
import { config } from "../config";
import { iframeSnippet, widgetSrc, wordpressModalShortcode, wordpressSettings, wordpressShortcode } from "../lib/snippets";
import { CodeBlock, CopyButton, Segmented } from "./ui";

/** How to put the calculator on a website: the WordPress plugin, or an iframe anywhere. */
export function InstallSnippets({ embedKey }: { embedKey: string }) {
  const [tab, setTab] = useState<"wordpress" | "iframe">("wordpress");
  return (
    <div className="stack" style={{ gap: 12 }}>
      <Segmented
        value={tab}
        onChange={setTab}
        options={[
          { value: "wordpress", label: "WordPress" },
          { value: "iframe", label: "Any website (iframe)" },
        ]}
      />
      {tab === "wordpress" ? (
        <div className="stack" style={{ gap: 10 }}>
          <ol className="muted" style={{ margin: 0, paddingLeft: 18, display: "grid", gap: 4 }}>
            <li>
              Install the <b>Solar Quote Pro</b> plugin (Plugins → Add New → Upload).
            </li>
            <li>
              In <b>Solar Quote Pro → Settings</b>, paste your embed key and API URL — no Google key needed:
            </li>
          </ol>
          <CodeBlock code={wordpressSettings(embedKey)} />
          <div className="spread">
            <span className="muted">
              Then add <code>{wordpressShortcode}</code> to a page, or <code>{wordpressModalShortcode}</code> for a popup button.
            </span>
            <div className="row">
              <CopyButton text={wordpressShortcode} label="Copy shortcode" />
              {config.wordpressPluginUrl && (
                <a className="btn btn-sm" href={config.wordpressPluginUrl} download>
                  <Download /> Download plugin
                </a>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="stack" style={{ gap: 10 }}>
          <p className="muted">Paste this where the calculator should appear (Squarespace, Wix, Webflow, HTML …). It only loads on the websites you allowed.</p>
          <CodeBlock code={iframeSnippet(embedKey)} />
          <div>
            <a className="btn btn-sm" href={widgetSrc(embedKey)} target="_blank" rel="noreferrer">
              <ExternalLink /> Open the hosted calculator
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
